module.exports = __webpack_public_path__ + "img/empty2.28a9f7bb.png";